import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { DashboardMetricTileGrid } from '@components/pages/Dashboard/Shared/DashboardMetricTileGrid.component'
import type { UseRevenueResult } from '@hooks/dashboard/useRevenue'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

type RevenueOverviewCardProps = {
  titleHref: string
  revenue: UseRevenueResult
}

export function RevenueOverviewCard({
  titleHref,
  revenue,
}: RevenueOverviewCardProps): React.ReactElement {
  const { cardMetrics, loading, hasData, hasPayload } = revenue
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Revenue Overview"
      titleHref={titleHref}
      className="dashboard-operations-revenue-card"
      loading={pending}
      skeleton={{ metrics: 4, block: 'none' }}
      isEmpty={isEmpty}
    >
      <DashboardMetricTileGrid metrics={cardMetrics} columns={4} />
    </DashboardSectionCard>
  )
}
